import React from "react";
import Scrollbars from "react-custom-scrollbars-2";
import { FiX } from "react-icons/fi";
import DrawerCancelNext from "components/form/DrawerCancelNext";
import DrawerPreviousSubmit from "components/form/DrawerPreviousSubmit";
import Error from "components/form/Error";
import InputName from "components/form/InputName";
import InputLicence from "components/form/InputLicence";
import InputAdhaar from "components/form/InputAdhaar";
import LabelArea from "components/form/LabelArea";
import InputMobileWoCodes from "components/form/InputMobileWoCode";
import Title from "components/form/Title";
import useDriverSubmit from "hooks/useDriverSubmit";
import SelectLanguages from "components/form/SelectLanguages";
import ActiveButton from "components/form/ActiveButton";
import Uploader from "components/image-uploader/Uploader";
import SelectReferenceNo from "components/form/SelectReferenceNo";

const DriverDrawer = ({ id }) => {
  const handleCancelPrimeImage = () => {
    setDriverImageUrl("");
  };

  const handleCancelLicenceImage = () => {
    setLicenseImageUrl("");
  };

  const {
    trigger,
    register,
    handleSubmit,
    onSubmit,
    handleNextStep,
    handlePreviousStep,
    selectedLanguages,
    setSelectedLanguages,
    setValue,
    errors,
    goToStep,
    step,
    driverImageUrl,
    setDriverImageUrl,
    licenseImageUrl,
    setLicenseImageUrl,
    selectedCountryCode,
    selectedReferenceNo,
    handleReferenceChange,
    loading,
    langId
  } = useDriverSubmit(id);

  return (
    <>
      <div className="w-full relative p-6 border-b border-gray-100 bg-gray-50 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300">
        {id ? <Title title={"Edit Driver"} /> : <Title title={"Add Driver"} />}
      </div>

      <div className="text-sm font-medium text-center text-gray-500 border-b border-gray-200 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-400">
        <ul className="flex flex-wrap -mb-px">
          <li className="mr-2">
            <ActiveButton
              tabValue={1}
              labelName="Basic Details"
              goToStep={goToStep}
              step={step}
            />
          </li>
          <li className="mr-2">
            <ActiveButton
              tabValue={2}
              labelName="Licence Details"
              goToStep={goToStep}
              step={step}
            />
          </li>
        </ul>
      </div>

      <Scrollbars className="w-full md:w-7/12 lg:w-8/12 xl:w-8/12 relative dark:bg-gray-700 dark:text-gray-200">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="px-6 pt-8 scrollbar-hide flex-grow w-full h-full max-h-full pb-40 md:pb-32 lg:pb-32 xl:pb-32">
            {step === 1 && (
              <>
                <div className="grid grid-cols-6 lg:grid-cols-12 gap-5">
                  <div className="col-span-6">
                    <LabelArea label={"Vendor"} required />
                    <SelectReferenceNo
                      register={register}
                      label="Vendor"
                      name="vendor_id"
                      selectedReferenceNoId={selectedReferenceNo}
                      handleReferenceNoChange={handleReferenceChange}
                    />
                    <Error errorName={errors.vendor_id} />
                  </div>

                  <div className="col-span-6">
                    <LabelArea label={"Driver Name"} required />
                    <InputName
                      trigger={trigger}
                      register={register}
                      label="Name"
                      name="driver_name"
                      type="text"
                      placeholder={"Jhon"}
                      pattern={/^[a-zA-Z\s.]+$/}
                    />
                    <Error errorName={errors.driver_name} />
                  </div>

                  <div className="col-span-6">
                    <LabelArea label={"Driver Contact"} required />
                    <InputMobileWoCodes
                      trigger={trigger}
                      register={register}
                      label="Mobile Number"
                      name="driver_contact_no"
                      type="tel"
                      minLength={10}
                      maxLength={10}
                      placeholder="Enter 10 digit"
                      pattern="^\d{10}$"
                      CountryCode={selectedCountryCode}
                      CountryCodeName="call_prefix"
                      onKeyDown={(e) => {
                        if (
                          !/^[0-9]$/.test(e.key) &&
                          e.key !== "Backspace" &&
                          e.key !== "Delete" &&
                          e.key !== "ArrowLeft" &&
                          e.key !== "ArrowRight"
                        ) {
                          e.preventDefault();
                        }
                      }}
                      onInput={(e) => {
                        e.target.value = e.target.value.replace(/[^0-9]/g, "");
                      }}
                    />
                    <Error errorName={errors.driver_contact_no} />
                  </div>

                  <div className="col-span-6">
                    <LabelArea label={"Driver Aadhaar (Optional)"} />
                    <InputAdhaar
                      trigger={trigger}
                      register={register}
                      required={false}
                      label="Aadhaar Number"
                      name="aadhaar_number"
                      type="text"
                      placeholder="Enter 12 digit"
                      pattern={/^\d{12}$/}
                      maxLength={12}
                      minLength={12}
                    />
                    <Error errorName={errors.aadhaar_number} />
                  </div>

                  <div className="col-span-6">
                    <LabelArea label={"Languages Known"} required />
                   <SelectLanguages
  name="languages_known"
  setValue={setValue}
  selectedLanguages={selectedLanguages} // This should be state variable
  setSelectedLanguages={setSelectedLanguages}
  langId={langId} // Example: ["6"]
 
/>
                    <Error errorName={errors.selectedLanguages} />
                  </div>

                  <div className="col-span-12">
                    <LabelArea label={"Driver Image (Optional)"} />
                    {driverImageUrl ? (
                      <div className="flex items-center">
                        <img
                          style={{
                            objectFit: "contain",
                            width: "100px",
                            height: "100px",
                          }}
                          src={
                            process.env.REACT_APP_API_IMAGE_URL + driverImageUrl
                          }
                          alt="caricon"
                        />
                        <FiX size={25} onClick={handleCancelPrimeImage} />
                      </div>
                    ) : (
                      <Uploader
                        is_multiple={false}
                        folder="driver"
                        name_merge="driver_img"
                        imageUrl={driverImageUrl}
                        setImageUrl={setDriverImageUrl}
                        no_of_image={1}
                      />
                    )}
                    <Error errorName={errors.driverImageUrl} />
                  </div>
                </div>

                <DrawerCancelNext handleNextStep={handleNextStep} />
              </>
            )}

            {step === 2 && (
              <>
                <div className="grid grid-cols-6 lg:grid-cols-12 gap-5">
                  <div className="col-span-12">
                    <LabelArea label={"License ID (Optional)"} />
                    <InputLicence
                      trigger={trigger}
                      register={register}
                      label="License ID"
                      name="driving_license"
                      type="text"
                      required={false}
                      placeholder={"DL1234567890123"}
                      pattern={/^[A-Z]{2}[0-9]{2}[0-9]{4}[0-9]{7}$/}
                      maxLength={15}
                      minLength={15}
                    />
                    <Error errorName={errors.driving_license} />
                  </div>

                  <div className="col-span-12">
                    <LabelArea label={"License Image (Optional)"} />
                    {licenseImageUrl ? (
                      <div className="flex items-center">
                        <img
                          style={{
                            objectFit: "contain",
                            width: "100px",
                            height: "100px",
                          }}
                          src={
                            process.env.REACT_APP_API_IMAGE_URL +
                            licenseImageUrl
                          }
                          alt="caricon"
                        />
                        <FiX size={25} onClick={handleCancelLicenceImage} />
                      </div>
                    ) : (
                      <Uploader
                        is_multiple={false}
                        folder="driver"
                        name_merge="license_img"
                        imageUrl={licenseImageUrl}
                        setImageUrl={setLicenseImageUrl}
                        no_of_image={1}
                      />
                    )}

                    <Error errorName={errors.licenseImageUrl} />
                  </div>
                </div>

                <DrawerPreviousSubmit
                  isSubmitting={loading}
                  handleNextStep={handleNextStep}
                  handlePreviousStep={handlePreviousStep}
                />
              </>
            )}
          </div>
        </form>
      </Scrollbars>
    </>
  );
};

export default DriverDrawer;
